import { blogArticles } from '@/data/blog';
import { newsArticles } from '@/data/news';

export const SITE_URL = 'https://www.docmoonlight.com';

export type SitemapRoute = {
  path: string;
  changeFrequency:
    | 'always'
    | 'hourly'
    | 'daily'
    | 'weekly'
    | 'monthly'
    | 'yearly'
    | 'never';
  priority: number;
};

export const staticSitemapRoutes: SitemapRoute[] = [
  { path: '/', changeFrequency: 'weekly', priority: 1 },
  { path: '/about', changeFrequency: 'monthly', priority: 0.8 },
  { path: '/founder', changeFrequency: 'monthly', priority: 0.7 },
  { path: '/contact', changeFrequency: 'monthly', priority: 0.8 },
  { path: '/what-we-offer', changeFrequency: 'monthly', priority: 0.9 },
  { path: '/virtual-coverage', changeFrequency: 'monthly', priority: 0.85 },
  { path: '/onsite-coverage', changeFrequency: 'monthly', priority: 0.85 },
  { path: '/hybrid-coverage', changeFrequency: 'monthly', priority: 0.85 },
  { path: '/teleradiology', changeFrequency: 'monthly', priority: 0.8 },
  { path: '/infusion', changeFrequency: 'monthly', priority: 0.85 },
  { path: '/residents', changeFrequency: 'monthly', priority: 0.9 },
  { path: '/resources', changeFrequency: 'monthly', priority: 0.7 },
  { path: '/blog', changeFrequency: 'weekly', priority: 0.8 },
  { path: '/news', changeFrequency: 'weekly', priority: 0.8 },
  { path: '/forum', changeFrequency: 'daily', priority: 0.7 },
];

export const contentSitemapRoutes: SitemapRoute[] = [
  ...blogArticles.map((article) => ({
    path: `/blog/${article.slug}`,
    changeFrequency: 'monthly' as const,
    priority: 0.75,
  })),
  ...newsArticles.map((article) => ({
    path: `/news/${article.slug}`,
    changeFrequency: 'monthly' as const,
    priority: 0.75,
  })),
];

export const getAbsoluteUrl = (path: string) =>
  `${SITE_URL}${path === '/' ? '' : path}`;
